/*eslint-disable*/
// eslint-disable-next-line no-unused-vars

import baseCommon from '@/api/moudle/common' //公共模块接口设置
import finance from '@/api/moudle/finance'; //财务管理模块接口配置
import userCenter from '@/api/moudle/userCenter'; //财务管理模块接口配置
import material from '@/api/moudle/material' //物资模块接口配置
import flowPath from '@/api/moudle/flowPath'; //流程管理配置
import administration from '@/api/moudle/administration'; //行政人事模块接口配置
import project from '@/api/moudle/project'; //项目模块模块接口配置
import activity from '@/api/moudle/activity'; //活动模块模块接口配置
 
//将相关接口模块曝露出去
export default {finance,userCenter,baseCommon,flowPath,material,administration,project,activity}